import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "errorMsg" }
const _hoisted_2 = { class: "errorMsg" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "errorMsg" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "errorMsg" }
const _hoisted_7 = { class: "errorMsg" }
const _hoisted_8 = { class: "d-flex w-100 mb-4" }
const _hoisted_9 = { class: "justify-content-start w-100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("small", null, "Forgot Password?", -1)
const _hoisted_11 = { class: "container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSelect2 = _resolveComponent("BaseSelect2")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseCheckBox = _resolveComponent("BaseCheckBox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
    class: "pt-2"
  }, [
    _createVNode(_component_BaseSelect2, {
      selectType: _ctx.categoryProp,
      category: _ctx.category,
      "onUpdate:category": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.category) = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('categoryChange', _ctx.category)))
    }, null, 8, ["selectType", "category"]),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.categoryError), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.directorateError), 1),
    (_ctx.category === 'Program Coordinator')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_BaseInput, {
            inputType: _ctx.emailProp,
            email: _ctx.email,
            "onUpdate:email": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
          }, null, 8, ["inputType", "email"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emailError), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_BaseInput, {
            inputType: _ctx.usernameProp,
            username: _ctx.username,
            "onUpdate:username": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.username) = $event))
          }, null, 8, ["inputType", "username"]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.usernameError), 1)
        ])),
    _createVNode(_component_BaseInput, {
      inputType: _ctx.passwordProp,
      password: _ctx.password,
      "onUpdate:password": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event))
    }, null, 8, ["inputType", "password"]),
    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.passwordError), 1),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("small", _hoisted_9, [
        _createVNode(_component_BaseCheckBox, {
          checkbox: _ctx.remember,
          "onUpdate:checkbox": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.remember) = $event)),
          inputType: _ctx.rememberProp
        }, null, 8, ["checkbox", "inputType"])
      ]),
      _createVNode(_component_router_link, { to: "forgot-password" }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_BaseButton, {
        disabled: _ctx.loading,
        class: _normalizeClass({ submitting: _ctx.loading }),
        customStyle: _ctx.buttonStyle
      }, {
        default: _withCtx(() => [
          _createTextVNode("Log in")
        ]),
        _: 1
      }, 8, ["disabled", "class", "customStyle"])
    ])
  ], 32))
}